import { render, staticRenderFns } from "./iconReplacement.vue?vue&type=template&id=43d13db2"
import script from "./iconReplacement.vue?vue&type=script&lang=js"
export * from "./iconReplacement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports